import { AppThunk } from 'src/redux/store';
import {
  setCurrentStep,
  setPageNumber,
  setVisitedScreens,
} from 'src/redux/reducers/form';
import {
  getCurrentStep,
  getExperiments,
  getInitialScreen,
  getInputQueryParams,
  getInputs,
  getIsSignedIn,
  getPageNumber,
  getVisitedScreens,
  getUserEmail,
  getIsMobileApp,
  getAuth0Variant,
} from 'src/redux/selectors';
import { FlowScreen } from 'src/lib/flows/flow-definition';
import { Screen } from 'src/lib/flows/screens';

export const getNextQuestion =
  (currentScreen: FlowScreen): AppThunk<Screen> =>
  (_dispatch, getState): Screen => {
    const state = getState();
    let nextQuestion: Screen;
    if (typeof currentScreen?.toScreen === 'function') {
      nextQuestion = currentScreen.toScreen({
        inputs: getInputs(state),
        queryParams: getInputQueryParams(state),
        experiments: getExperiments(state),
        isSignedIn: getIsSignedIn(state),
        userEmail: getUserEmail(state),
        isMobileApp: getIsMobileApp(state),
        auth0Variant: getAuth0Variant(state),
      });
    } else {
      nextQuestion = currentScreen?.toScreen[0];
    }
    return nextQuestion;
  };

export const updateFormValues =
  (screenName: Screen): AppThunk =>
  (dispatch, getState): void => {
    const state = getState();
    const visitedScreens = getVisitedScreens(state);
    const currentStep = getCurrentStep(state);
    const pageNum = getPageNumber(state);
    const initialScreen = getInitialScreen(state);

    // Don't update initial state
    if (initialScreen === screenName && visitedScreens.length === 1) return;

    const currentStepIndex = visitedScreens.lastIndexOf(screenName);
    const previousStepIndex = visitedScreens.lastIndexOf(currentStep);
    const pageNumber =
      currentStepIndex < 0 || currentStepIndex > previousStepIndex
        ? pageNum + 1
        : pageNum - 1;

    dispatch(setPageNumber(pageNumber));
    dispatch(setCurrentStep(screenName));
    const newVisitedScreens: Screen[] = [
      ...visitedScreens,
      ...(visitedScreens.includes(screenName) ? [] : [screenName]),
    ];
    dispatch(setVisitedScreens(newVisitedScreens));
  };
